import * as Dtos from "../dtos/Tmd.dtos";
import { IFormFilter } from "../reducers/index";

export const
    LoadCommitteeMember: ICommitteeMemberLoadActionCreator = (committeeId) => {
        return {
            type: ACTION_COMMITTEEMEMBER_LOAD,
            committeeId
        }
    },
    LoadCommitteeMemberById: ICommitteeMemberLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_COMMITTEEMEMBER_LOAD_BY_ID,
            id
        }
    },
    LoadCommitteeMemberByCommitteeId: ICommitteeMemberLoadByCommitteeIdActionCreator = (committeeId) => {
        return {
            type: ACTION_COMMITTEEMEMBER_LOAD_BY_COMMITTEE_ID,
            committeeId
        }
    },
    LoadSuccess: ICommitteeMemberLoadSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_COMMITTEEMEMBER_LOAD_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: ICommitteeMemberLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_COMMITTEEMEMBER_LOAD_FAILURE,
            responseStatus
        }
    },

    SaveCommitteeMember: ICommitteeMemberSaveActionCreator = (formData) => {
        return {
            type: ACTION_COMMITTEEMEMBER_SAVE,
            formData
        }
    },
    SaveSuccess: ICommitteeMemberSaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_COMMITTEEMEMBER_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: ICommitteeMemberSaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_COMMITTEEMEMBER_SAVE_FAILURE,
            responseStatus
        }
    },

    CreateCommitteeMember: ICommitteeMemberCreateActionCreator = (committeeId) => {
        return {
            type: ACTION_COMMITTEEMEMBER_CREATE,
            committeeId
        }
    },
    CreateSuccess: ICommitteeMemberCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_COMMITTEEMEMBER_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: ICommitteeMemberCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_COMMITTEEMEMBER_CREATE_FAILURE,
            responseStatus
        }
    },

    ValidateCommitteeMember: ICommitteeMemberValidateActionCreator = (formData) => {
        return {
            type: ACTION_COMMITTEEMEMBER_VALIDATE,
            formData
        }
    },
    ValidateSuccess: ICommitteeMemberValidateSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_COMMITTEEMEMBER_VALIDATE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    ValidateFailure: ICommitteeMemberValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_COMMITTEEMEMBER_VALIDATE_FAILURE,
            responseStatus
        }
    },

    Clear: ICommitteeMemberClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_COMMITTEEMEMBER_CLEAR,
            propertiesToClear
        }
    },

    Filter: ICommitteeMemberFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_COMMITTEEMEMBER_FILTER,
            formFilter
        }
    };



export const
    ACTION_COMMITTEEMEMBER_LOAD = "ACTION_COMMITTEEMEMBER_LOAD",
    ACTION_COMMITTEEMEMBER_LOAD_BY_ID = "ACTION_COMMITTEEMEMBER_LOAD_BY_ID",
    ACTION_COMMITTEEMEMBER_LOAD_BY_COMMITTEE_ID = "ACTION_COMMITTEEMEMBER_LOAD_BY_COMMITTEE_ID",
    ACTION_COMMITTEEMEMBER_LOAD_SUCCESS = "ACTION_COMMITTEEMEMBER_LOAD_SUCCESS",
    ACTION_COMMITTEEMEMBER_LOAD_FAILURE = "ACTION_COMMITTEEMEMBER_LOAD_FAILURE",

    ACTION_COMMITTEEMEMBER_SAVE = "ACTION_COMMITTEEMEMBER_SAVE",
    ACTION_COMMITTEEMEMBER_SAVE_SUCCESS = "ACTION_COMMITTEEMEMBER_SAVE_SUCCESS",
    ACTION_COMMITTEEMEMBER_SAVE_FAILURE = "ACTION_COMMITTEEMEMBER_SAVE_FAILURE",

    ACTION_COMMITTEEMEMBER_CREATE = "ACTION_COMMITTEEMEMBER_CREATE",
    ACTION_COMMITTEEMEMBER_CREATE_SUCCESS = "ACTION_COMMITTEEMEMBER_CREATE_SUCCESS",
    ACTION_COMMITTEEMEMBER_CREATE_FAILURE = "ACTION_COMMITTEEMEMBER_CREATE_FAILURE",

    ACTION_COMMITTEEMEMBER_VALIDATE = "ACTION_COMMITTEEMEMBER_VALIDATE",
    ACTION_COMMITTEEMEMBER_VALIDATE_SUCCESS = "ACTION_COMMITTEEMEMBER_VALIDATE_SUCCESS",
    ACTION_COMMITTEEMEMBER_VALIDATE_FAILURE = "ACTION_COMMITTEEMEMBER_VALIDATE_FAILURE",

    ACTION_COMMITTEEMEMBER_CLEAR = "ACTION_COMMITTEEMEMBER_CLEAR",

    ACTION_COMMITTEEMEMBER_FILTER = "ACTION_COMMITTEEMEMBER_FILTER";

export interface ICommitteeMemberLoadAction {
    type: "ACTION_COMMITTEEMEMBER_LOAD";
    committeeId: number;
}

export interface ICommitteeMemberLoadActionCreator {
    (committeeId: number): ICommitteeMemberLoadAction;
}

export interface ICommitteeMemberLoadSuccessAction {
    type: "ACTION_COMMITTEEMEMBER_LOAD_SUCCESS";
    formData: Dtos.CommitteeMember | Dtos.CommitteeMember[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface ICommitteeMemberLoadSuccessActionCreator {
    (
        formData: Dtos.CommitteeMember | Dtos.CommitteeMember[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): ICommitteeMemberLoadSuccessAction;
}

export interface ICommitteeMemberLoadFailureAction {
    type: "ACTION_COMMITTEEMEMBER_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface ICommitteeMemberLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ICommitteeMemberLoadFailureAction;
}

export interface ICommitteeMemberLoadByIdAction {
    type: "ACTION_COMMITTEEMEMBER_LOAD_BY_ID";
    id: number;
}

export interface ICommitteeMemberLoadByIdActionCreator {
    (id: number): ICommitteeMemberLoadByIdAction;
}

export interface ICommitteeMemberLoadByCommitteeIdAction {
    type: "ACTION_COMMITTEEMEMBER_LOAD_BY_COMMITTEE_ID";
    committeeId: number;
}

export interface ICommitteeMemberLoadByCommitteeIdActionCreator {
    (committeeId: number): ICommitteeMemberLoadByCommitteeIdAction;
}

export interface ICommitteeMemberSaveAction {
    type: "ACTION_COMMITTEEMEMBER_SAVE";
    formData: Dtos.CommitteeMember;

}

export interface ICommitteeMemberSaveActionCreator {
    (
        formData: Dtos.CommitteeMember
    ): ICommitteeMemberSaveAction;
}

export interface ICommitteeMemberSaveSuccessAction {
    type: "ACTION_COMMITTEEMEMBER_SAVE_SUCCESS";
    formData: Dtos.CommitteeMember;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ICommitteeMemberSaveSuccessActionCreator {
    (
        formData: Dtos.CommitteeMember,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ICommitteeMemberSaveSuccessAction;
}

export interface ICommitteeMemberSaveFailureAction {
    type: "ACTION_COMMITTEEMEMBER_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ICommitteeMemberSaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ICommitteeMemberSaveFailureAction;
}

export interface ICommitteeMemberCreateAction {
    type: "ACTION_COMMITTEEMEMBER_CREATE",
    committeeId: number
}

export interface ICommitteeMemberCreateActionCreator {
    (committeeId: number): ICommitteeMemberCreateAction
}

export interface ICommitteeMemberCreateSuccessAction {
    type: "ACTION_COMMITTEEMEMBER_CREATE_SUCCESS";
    formData: Dtos.CommitteeMember;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
}

export interface ICommitteeMemberCreateSuccessActionCreator {
    (
        formData: Dtos.CommitteeMember,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): ICommitteeMemberCreateSuccessAction;
}

export interface ICommitteeMemberCreateFailureAction {
    type: "ACTION_COMMITTEEMEMBER_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ICommitteeMemberCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ICommitteeMemberCreateFailureAction;
}

export interface ICommitteeMemberValidateAction {
    type: "ACTION_COMMITTEEMEMBER_VALIDATE";
    formData: Dtos.CommitteeMember;

}

export interface ICommitteeMemberValidateActionCreator {
    (
        formData: Dtos.CommitteeMember
    ): ICommitteeMemberValidateAction;
}

export interface ICommitteeMemberValidateSuccessAction {
    type: "ACTION_COMMITTEEMEMBER_VALIDATE_SUCCESS";
    formData: Dtos.CommitteeMember;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ICommitteeMemberValidateSuccessActionCreator {
    (
        formData: Dtos.CommitteeMember,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ICommitteeMemberValidateSuccessAction;
}

export interface ICommitteeMemberValidateFailureAction {
    type: "ACTION_COMMITTEEMEMBER_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ICommitteeMemberValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ICommitteeMemberValidateFailureAction;
}

export interface ICommitteeMemberClearAction {
    type: "ACTION_COMMITTEEMEMBER_CLEAR";
    propertiesToClear?: string[];
}

export interface ICommitteeMemberClearActionCreator {
    (propertiesToClear?: string[]): ICommitteeMemberClearAction;
}

export interface ICommitteeMemberFilterActionCreator {
    (formFilter: IFormFilter): ICommitteeMemberFilterAction;
}

export interface ICommitteeMemberFilterAction {
    type: "ACTION_COMMITTEEMEMBER_FILTER";
    formFilter: IFormFilter;
}


export type CommitteeMemberAction =
    ICommitteeMemberLoadAction |
    ICommitteeMemberLoadByIdAction |
    ICommitteeMemberLoadByCommitteeIdAction |
    ICommitteeMemberLoadFailureAction |
    ICommitteeMemberLoadSuccessAction |
    ICommitteeMemberSaveAction |
    ICommitteeMemberSaveSuccessAction |
    ICommitteeMemberSaveFailureAction |
    ICommitteeMemberCreateAction |
    ICommitteeMemberCreateSuccessAction |
    ICommitteeMemberCreateFailureAction |
    ICommitteeMemberValidateAction |
    ICommitteeMemberValidateSuccessAction |
    ICommitteeMemberValidateFailureAction |
    ICommitteeMemberClearAction | 
    ICommitteeMemberFilterAction;
